import React, { Component } from 'react';
import { Container } from 'flux/utils';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { discardCompliance, saveAndDiscardCompliance } from '../../actions/ComplianceActionCreator';
import ComplianceStore from '../../stores/ComplianceStore';
import ComplianceForm from './ComplianceForm';

class ComplianceEditDialog extends Component {
    render() {
        const { draft } = this.state;
        const dialogActions = [
            <FlatButton key="cancel" label="Cancel" onTouchTap={discardCompliance}/>,
            <FlatButton
                primary={true}
                key="submit"
                label="Save"
                disabled={!draft || !draft.name}
                onTouchTap={saveAndDiscardCompliance}
            />
        ];
        return (
            <Dialog
                title="Compliance"
                open={!!draft}
                actions={dialogActions}
            >
                <ComplianceForm draft={draft} onSave={saveAndDiscardCompliance} {...this.props} />
            </Dialog>
        );
    }
}

ComplianceEditDialog.getStores = () => ([ComplianceStore]);
ComplianceEditDialog.calculateState = prevState => ({
    draft: ComplianceStore.getDraft()
});

export default Container.create(ComplianceEditDialog);

